import roles from '@/app/drilling/roles.js'
import pageDefinition from '@/app/shared/pageDefinition'
import features from "@/app/shared/AppFeatures.js"

export default class pages {
  mainMenu = null;
  staging = null;
  stagingEdit = null;
  stagingView = null;
  unmapped = null;
  dashboard = null;
  contracts = null;
  projects = null;
  projectEdit = null;
  drills = null;
  companies = null;
  employeeTitles = null;
  employees = null;
  tasks = null;
  instruments = null;
  coreBarrels = null;
  cementation = null;
  holes = null;
  upload = null;

  constructor() {
    this.mainMenu = new pageDefinition("/drilling/", "Drilling", roles.readers, "CrosshairIcon", "Drilling.MainTitle", "Drilling", true, () => import("@/app/drilling/index.vue"));
    this.mainMenu.addSelfToBreadcrumb();
    this.mainMenu.userGuideUrl = {
      en: "https://agnicoeagle.sharepoint.com/:b:/r/sites/GRP_Digital_Transformation/Shared%20Documents/Project%20Management/DS-21-0004-AEM-Drilling/Doc/UserGuide/V2/Drilling_User_Guide_V2EN.pdf?csf=1&web=1&e=Fs3Fyu",
      fr: "https://agnicoeagle.sharepoint.com/:b:/r/sites/GRP_Digital_Transformation/Shared%20Documents/Project%20Management/DS-21-0004-AEM-Drilling/Doc/UserGuide/V2/Drilling_User_Guide_V2FR.pdf?csf=1&web=1&e=9Epw35"
    }

    this.staging = new pageDefinition("/drilling/staging", "drilling-staging", roles.collaborators, "ClockIcon", "Drilling.DailyReports.Title", "DailyReports", true, () => import("@/app/drilling/staging/index.vue"), "editor");
    this.staging.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.staging.addSelfToBreadcrumb();

    this.unmapped = new pageDefinition("/drilling/unmapped", "drilling-unmapped", roles.collaborators, "ClockIcon", "Drilling.Unmapped.Title", "Unmapped", true, () => import("@/app/drilling/unmapped/index.vue"), "editor");
    this.unmapped.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.unmapped.addSelfToBreadcrumb();

    this.cementation = new pageDefinition("/drilling/cementation", "drilling-cementation", roles.collaborators, "ClockIcon", "Drilling.Cementation.Title", "Cementation", true, () => import("@/app/drilling/cementation/index.vue"), "editor");
    this.cementation.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.cementation.addSelfToBreadcrumb();

    this.stagingEdit = new pageDefinition("/drilling/staging/:stagingDailyReportId/edit", "drilling-staging-edit", roles.collaborators, "ClockIcon", "Drilling.DailyReports.Edit", "DailyReportsEdit", true, () => import("@/app/drilling/staging/edit.vue"), "editor");
    this.stagingEdit.props = (route) => ({ id: parseInt(route.params.stagingDailyReportId) });
    this.stagingEdit.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.stagingEdit.addItemToBreadcrumb(this.staging.toBreadcrumb(false));
    this.stagingEdit.addSelfToBreadcrumb();

    this.stagingAdd = new pageDefinition("/drilling/staging/add", "drilling-staging-add", roles.collaborators, "ClockIcon", "Drilling.DailyReports.Add", "DailyReportsAdd", true, () => import("@/app/drilling/staging/edit.vue"), "editor");
    this.stagingAdd.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.stagingAdd.addItemToBreadcrumb(this.staging.toBreadcrumb(false));
    this.stagingAdd.addSelfToBreadcrumb();

    this.stagingView = new pageDefinition("/drilling/staging/view", "drilling-staging-view", roles.collaborators, "ClockIcon", "Drilling.DailyReports.View", "DailyReportsView", true, () => import("@/app/drilling/staging/view.vue"), "editor");
    this.stagingView.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.stagingView.addItemToBreadcrumb(this.staging.toBreadcrumb(false));
    this.stagingView.addSelfToBreadcrumb();
    
    this.contracts = new pageDefinition("/drilling/contracts", "drilling-contracts", roles.collaborators, "FileTextIcon", "Drilling.Contracts.Title", "Contracts", true, () => import("@/app/drilling/contracts/index.vue"), "editor");
    this.contracts.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.contracts.addSelfToBreadcrumb();

    this.projects = new pageDefinition("/drilling/projects", "drilling-projects", roles.collaborators, "EditIcon", "Drilling.Projects.Title", "Projects", true, () => import("@/app/drilling/projects/index.vue"), "editor");
    this.projects.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.projects.addSelfToBreadcrumb();

    this.projectEdit = new pageDefinition("/drilling/projects/edit", "drilling-projects-edit", roles.collaborators, "EditIcon", "Drilling.Projects.Edit", "ProjectsEdit", true, () => import("@/app/drilling/projects/edit.vue"), "editor");
    this.projectEdit.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.projectEdit.addItemToBreadcrumb(this.projects.toBreadcrumb(false));
    this.projectEdit.addSelfToBreadcrumb();

    this.drills = new pageDefinition("/drilling/drills", "drilling-drills", roles.collaborators, "TruckIcon", "Drilling.Drills.Title", "Drills", true, () => import("@/app/drilling/drills/index.vue"), "editor");
    this.drills.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.drills.addSelfToBreadcrumb();
    
    this.companies = new pageDefinition("/drilling/companies", "drilling-companies", roles.collaborators, "GlobeIcon", "Drilling.Companies.Title", "Companies", true, () => import("@/app/drilling/admin/companies/index.vue"), "editor");
    this.companies.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.companies.addSelfToBreadcrumb();

    this.employeeTitles = new pageDefinition("/drilling/employeeTitles", "drilling-employeeTitles", roles.admins, "UserIcon", "Drilling.EmployeeTitles.Title", "EmployeeTitles", true, () => import("@/app/drilling/admin/employeeTitles/index.vue"), "editor");
    this.employeeTitles.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.employeeTitles.addSelfToBreadcrumb();
    
    this.employees = new pageDefinition("/drilling/employees", "drilling-employees", roles.collaborators, "UsersIcon", "Drilling.Employees.Title", "Employees", true, () => import("@/app/drilling/admin/employees/index.vue"), "editor");
    this.employees.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.employees.addSelfToBreadcrumb();

    this.tasks = new pageDefinition("/drilling/tasks", "drilling-tasks", roles.collaborators, "ListIcon", "Drilling.Tasks.Title", "Tasks", true, () => import("@/app/drilling/admin/tasks/index.vue"), "editor");
    this.tasks.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.tasks.addSelfToBreadcrumb();

    this.instruments = new pageDefinition("/drilling/instruments", "drilling-instruments", roles.collaborators, "ToolIcon", "Drilling.Instruments.Title", "Tasks", true, () => import("@/app/drilling/admin/instruments/index.vue"), "editor");
    this.instruments.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.instruments.addSelfToBreadcrumb();

    this.coreBarrels = new pageDefinition("/drilling/coreBarrels", "drilling-coreBarrels", roles.collaborators, "PenToolIcon", "Drilling.CoreBarrels.Title", "Tasks", true, () => import("@/app/drilling/admin/coreBarrels/index.vue"), "editor");
    this.coreBarrels.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.coreBarrels.addSelfToBreadcrumb();

    this.holes = new pageDefinition("/drilling/holes", "drilling-holes", roles.collaborators, "ThermometerIcon", "Drilling.Holes.Title", "Tasks", true, () => import("@/app/drilling/holes/index.vue"), "editor");
    this.holes.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.holes.addSelfToBreadcrumb();

    this.upload = new pageDefinition("/drilling/upload", "drilling-upload", roles.collaborators, "UploadIcon", "Drilling.Upload.Title", "Tasks", true, () => import("@/app/drilling/upload/index.vue"), "editor", features.Drilling.UploadVue2);
    this.upload.featureFlag = features.Drilling.DailyReports.UploadVue2;
    this.upload.addItemToBreadcrumb(this.mainMenu.toBreadcrumb(false));
    this.upload.addSelfToBreadcrumb();
  }

  getMenuItems() {
    const items = [];
    items.push(this.staging.toMenuItem());
    items.push(this.unmapped.toMenuItem());
    items.push(this.cementation.toMenuItem());
    items.push(this.holes.toMenuItem());
    items.push(this.upload.toMenuItem());
    return items;
  }

  getAdminMenuItems() {
    const items = [];
    items.push(this.projects.toMenuItem());
    items.push(this.contracts.toMenuItem());
    items.push(this.drills.toMenuItem());
    items.push(this.employeeTitles.toMenuItem());
    items.push(this.employees.toMenuItem());
    items.push(this.tasks.toMenuItem());
    items.push(this.instruments.toMenuItem());
    items.push(this.coreBarrels.toMenuItem());    
    items.push(this.companies.toMenuItem());
    return items;
  }

  getNavMenu() {
    const subMenu = [];
    subMenu.push(this.staging.toNavMenuItem());
    subMenu.push(this.cementation.toNavMenuItem());
    subMenu.push(this.projects.toNavMenuItem());
    subMenu.push(this.contracts.toNavMenuItem());
    subMenu.push(this.drills.toNavMenuItem());
    subMenu.push(this.holes.toNavMenuItem());
    subMenu.push(this.upload.toNavMenuItem());
    const mainItem = this.mainMenu.toNavMenuItem(subMenu);
    return mainItem;
  }

  getRoutes() {
    const items = [];
    items.push(this.mainMenu.toRoute());
    items.push(this.staging.toRoute());
    items.push(this.stagingEdit.toRoute());
    items.push(this.stagingView.toRoute());
    items.push(this.unmapped.toRoute());
    items.push(this.projects.toRoute());
    items.push(this.projectEdit.toRoute());
    items.push(this.contracts.toRoute());
    items.push(this.drills.toRoute());
    items.push(this.employeeTitles.toRoute());
    items.push(this.employees.toRoute());
    items.push(this.tasks.toRoute());
    items.push(this.instruments.toRoute());
    items.push(this.coreBarrels.toRoute());
    items.push(this.companies.toRoute());
    items.push(this.cementation.toRoute());
    items.push(this.holes.toRoute());
    items.push(this.upload.toRoute());
    items.push(this.stagingAdd.toRoute());
    return items;
  }
}
